import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { ApiResponse } from '../core/models/api-response.model';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class AdminHierarchyService {

    private http = inject(HttpClient);
    private API_URL_PREFIX: string = environment.apiURL + '/' + 'admin/administrative-hierarchies';
    private httpOptions = {
        headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    };

    findAll(queryParams?: any) {
        let params = new HttpParams();
        if (queryParams) {
            for (const key in queryParams) {
                if (Object.prototype.hasOwnProperty.call(queryParams, key)) {
                    params = params.set(key, queryParams[key]);
                }
            }
        }
        return this.http.get(this.API_URL_PREFIX, {
            headers: this.httpOptions.headers,
            params: params
        });
    }

    create(payload: any) {
        return this.http.post(this.API_URL_PREFIX, payload, this.httpOptions);
    }

    update(id: any, data: any) {
        return this.http.put(this.API_URL_PREFIX + '/' + id, data, this.httpOptions);
    }

    delete(id: string) {
        return this.http.delete(this.API_URL_PREFIX + '/' + id)
    }
}
